import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {InputSwitch} from "primereact/inputswitch";
import {AutoComplete} from "primereact/autocomplete";
import {Panel} from "primereact/panel";
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import axios from "axios";

const UserFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const canSetRoles = (localStorage.getItem('roles') || '').toLowerCase().includes('role_set_role');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [employees, setEmployees] = useState([]);
  const [employeeDisplay, setEmployeeDisplay] = useState("");
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [employeeSelected, setEmployeeSelected] = useState(false);
  const [rolegroups, setRolegroups] = useState([]);
  const [selectedRoleGroups, setSelectedRoleGroups] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [newFormData, setNewFormData] = useState({});
  const savedUserId = window.App.urlVars().userId ?? id ?? formData.id;
  const [roleGroupSearch, setRoleGroupSearch] = useState('');
  const [directRoleSearch, setDirectRoleSearch] = useState('');
  const [allUserRoleSearch, setAllUserRoleSearch] = useState('');

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      ...newFormData,
      active: newFormData.active ?? !!formData.active
    };
    if ((window.App.urlVars().userId) || (entity === 'user' && id)) {
      apiCall('patch', '/api/v2/user/' + (window.App.urlVars().userId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderUserList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/user', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderUserList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/settings/user/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const sortByName = (items = []) => {
    return [...items].sort((a, b) =>
      (a?.name || a?.code || '').localeCompare(
        b?.name || b?.code || '',
        'hu',
        { sensitivity: 'base' }
      )
    );
  };

  const filterByNameOrCode = (items = [], search = '') => {
    const q = (search || '').toLowerCase().trim();
    if (!q) {
      return items;
    }
    return items.filter(item =>
      (item?.name || '').toLowerCase().includes(q) ||
      (item?.code || '').toLowerCase().includes(q)
    );
  };

  const searchEmployee = (event) => {
    const query = (event.query || "").toLowerCase().trim();
    if (!query) {
      setEmployeeSuggestions([]);
      return;
    }
    const filtered = employees
      .filter(e => ((e.name || "").toLowerCase()).includes(query))
      .map(e => ({ ...e, name: e.name }));
    setEmployeeSuggestions(filtered);
  };

  const savePermissions = () => {
    const userId = window.App.urlVars().userId ?? id;
    if (!userId) {
        window.App.toastShow('error', 'Hiba', 'Kérjük, először mentse el a felhasználó alapadatait!');
        return;
    }
    setLoading(true);
    const payload = {
      direct_roles: selectedRoles
        .filter(role => role && role.code) 
        .map(role => role.code),
      role_groups: selectedRoleGroups
        .filter(group => group && group.id)
        .map(group => group.id)
    };
    apiCall('patch', '/api/v2/user/' + userId, payload)
      .then(response => {
        window.App.toastShow('success', 'Jogosultságok sikeresen frissítve!');
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString());
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    apiCall('get', '/api/v2/dictionary/role?limit=9999')
    .then(roleDictResponse => {
      const allRoles = sortByName(roleDictResponse.data?.data || []);
      setRoles(allRoles);
      const userId = window.App.urlVars().userId ?? id;
      if ((!window.App.urlVars().create && window.App.urlVars().userId) || (entity === 'user' && id)) {
        return apiCall('get', '/api/v2/user/' + userId)
          .then(userResponse => {
            const userData = userResponse.data.data;
            const formattedData = {
              ...userData,
              employee: userData.employee?.id || userData.employee 
            };
            setFormData(formattedData);
            setSelectedRoleGroups(userData.role_groups || []);
            if (userData.employee?.name) {
              setEmployeeDisplay(userData.employee.name);
            }
            if (userData.roles && Array.isArray(userData.roles)) {
              const mappedRoles = userData.roles.map(roleCode => {
                const foundRole = allRoles.find(r => r.code === roleCode);
                return foundRole ? foundRole : { code: roleCode, name: roleCode };
              });
              setSelectedRoles(sortByName(mappedRoles));
            }
          });
      }
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    })
    .finally(() => {
      setLoading(false);
    });
    apiCall('get', '/api/v2/employee?limit=9999')
      .then(response => {
        const list = response.data?.data?.items || [];
        setEmployees(list);
        if (formData?.employee && typeof formData.employee === 'object') {
          setEmployeeDisplay(formData.employee.name || "");
        } else if (formData?.employee) {
          const hit = list.find(e => String(e.id) === String(formData.employee));
          if (hit) setEmployeeDisplay(hit.name || "");
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/role-group?limit=9999')
      .then(response => {
        const list = response.data?.data?.items || [];
        setRolegroups(sortByName(list));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  useEffect(() => {
    const urlVars = window.App.urlVars();
    if (urlVars.employeeName) {
      const decodedName = decodeURIComponent(urlVars.employeeName);
      setEmployeeDisplay(decodedName);
      setFormData(prev => ({
        ...prev,
        employee: urlVars.employeeId || prev.employee
      }));
      setNewFormData(prev => ({
        ...prev,
        employee: urlVars.employeeId || prev.employee
      }));
    }
  }, [window.App.urlVars().employeeName]);

  return (
    <div className={"user-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('columnName2')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="employee" render={({ meta }) => (
                <div className="p-field p-fluid">
                  <label
                    htmlFor="employee"
                    className={classNames({ 'p-error': isFormFieldValid(meta) })}
                  >{props.t('employee')}</label>
                  <span className="p-inputgroup">
                    <Button
                      type="button"
                      className="p-button"
                      onClick={() => {
                        let paramsObj = { ...window.App.urlVars() };
                        paramsObj.search = 'employee';
                        let _params = "?";
                        Object.entries(paramsObj).forEach(([key, value]) => {
                          _params += key + "=" + value + "&";
                        });
                        history.push(window.location.hash.replace("#", "") + _params);
                      }}
                    >
                      <i className="pi pi-search"></i>
                    </Button>
                    <AutoComplete
                      id="employee"
                      value={employeeDisplay}
                      suggestions={employeeSuggestions}
                      completeMethod={searchEmployee}
                      field="name"
                      delay={800}
                      forceSelection
                      placeholder={t('typeToSearchPlaceholder')}className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                      onSelect={(e) => {
                        const picked = e.value;
                        setEmployeeSelected(true);
                        setEmployeeDisplay(picked?.name || "");
                        const eid = picked?.id || null;
                        setFormData(prev => ({ ...prev, employee: eid }));
                        setNewFormData(prev => ({ ...prev, employee: eid }));
                      }}
                      onChange={(e) => {
                        if (employeeSelected) {
                          setEmployeeSelected(false);
                          return;
                        }
                        setEmployeeDisplay(e.value);
                        setFormData(prev => ({ ...prev, employee: null }));
                        setNewFormData(prev => ({ ...prev, employee: null }));
                      }}
                      onClear={() => {
                        setEmployeeDisplay("");
                        setFormData(prev => ({ ...prev, employee: null }));
                        setNewFormData(prev => ({ ...prev, employee: null }));
                      }}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>

            

            <div className={"p-col-12 p-lg-6"}>
              <Field name="email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmail')}</label>
                  <span className="p-d-block">
                      <InputText id="email" {...input}
                                 onChange={(e) => {
                                  const value = e.target.value;
                                  setFormData(prev => {
                                    const shouldSyncIdentifier =
                                      !prev.identifier || prev.identifier === prev.email;
                                    return {
                                      ...prev,
                                      email: value,
                                      identifier: shouldSyncIdentifier ? value : prev.identifier
                                    };
                                  });
                                  setNewFormData(prev => {
                                    const currentIdentifier = formData.identifier;
                                    const currentEmail = formData.email;
                                    const shouldSyncIdentifier =
                                      !currentIdentifier || currentIdentifier === currentEmail;
                                    return {
                                      ...prev,
                                      email: value,
                                      identifier: shouldSyncIdentifier ? value : prev.identifier
                                    };
                                  });
                                }}
                                 value={formData.email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="identifier" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="identifier"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIdentifier')}</label>
                  <span className="p-d-block">
                      <InputText id="identifier" {...input}
                                 onChange={(e) => {
                                  const value = e.target.value;
                                  setFormData(prev => ({
                                    ...prev,
                                    identifier: value
                                  }));
                                  setNewFormData(prev => ({
                                    ...prev,
                                    identifier: value
                                  }));
                                }}
                                 value={formData.identifier}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className="p-col-12 p-lg-4">
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  <div className="field-control">
                    <InputSwitch
                      checked={!!formData.active}
                      onChange={(e) => {
                        const v = !!e.value;
                        setFormData(prev => ({ ...prev, active: v }));
                        setNewFormData(prev => ({ ...prev, active: v }));
                      }}
                    />  
                    {getFormErrorMessage(meta)}
                  </div>
                </div>
              )}/>
            </div>

          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'user' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
          {savedUserId && canSetRoles && (
          <div className="p-grid p-mt-3">
            <div className={"p-col-12 p-lg-4"}>
                <Panel>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-text-left"}>
                      <h3 className={"p-m-0 p-p-0 text-primary"}>
                        {t('availableRoles')}
                      </h3>
                    </div>
                    <div className={"p-col-12 p-text-left"}>
                      <InputText
                        value={roleGroupSearch}
                        onChange={(e) => setRoleGroupSearch(e.target.value)}
                        placeholder={t('dsSearch')}
                        className="p-inputtext-sm"
                        style={{ width: '180px' }}
                      />
                    </div>
                  </div>
                  <DataTable
                    emptyMessage={t('noResults')}
                    size={"small"}
                    value={filterByNameOrCode(rolegroups, roleGroupSearch)}
                    selection={selectedRoleGroups}
                    autoLayout
                    filterDisplay="none"
                    responsiveLayout="scroll"
                    stripedRows
                    dataKey="id"
                    onSelectionChange={(e) => {
                      setSelectedRoleGroups(sortByName(e.value));
                    }}
                  >
                    <Column selectionMode="multiple" headerStyle={{width: '3rem'}}/>
                    <Column header={t('columnName')}
                      body={(rowData) => ( rowData?.name || "" )}
                    />
                  </DataTable>
                </Panel>
            </div>


            <div className={"p-col-12 p-lg-4"}>
                <Panel>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-text-left"}>
                      <h3 className={"p-m-0 p-p-0 text-primary"}>
                        Egyedi jogosultságok
                      </h3>
                    </div>
                    <div className={"p-col-12 p-text-left"}>
                      <InputText
                        value={directRoleSearch}
                        onChange={(e) => setDirectRoleSearch(e.target.value)}
                        placeholder={t('dsSearch')}
                        className="p-inputtext-sm"
                        style={{ width: '180px' }}
                      />
                    </div>
                  </div>
                  <DataTable
                    emptyMessage={t('noResults')}
                    size={"small"}
                    value={filterByNameOrCode(sortByName(roles.filter(role => {
                      const rolesInGroups = selectedRoleGroups.flatMap(group => group.roles || []);
                      return !rolesInGroups.includes(role.code);
                    })), directRoleSearch)}
                    selection={selectedRoles}
                    autoLayout
                    filterDisplay="none"
                    responsiveLayout="scroll"
                    stripedRows
                    dataKey="code"
                    onSelectionChange={(e) => {
                      setSelectedRoles(sortByName(e.value));
                    }}
                  >
                    <Column selectionMode="multiple" headerStyle={{width: '3rem'}}/>
                    <Column header={t('columnName')}
                      body={(rowData) => ( rowData?.name || "" )}
                    />
                  </DataTable>
                </Panel>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Panel>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-text-left"}>
                      <h3 className={"p-m-0 p-p-0 text-primary"}>
                        Felhasználó összes jogosultsága
                      </h3>
                    </div>
                    <div className={"p-col-12 p-text-left"}>
                      <InputText
                        value={allUserRoleSearch}
                        onChange={(e) => setAllUserRoleSearch(e.target.value)}
                        placeholder={t('dsSearch')}
                        className="p-inputtext-sm"
                        style={{ width: '180px' }}
                      />
                    </div>
                  </div>
                  <DataTable
                      emptyMessage={t('noAssignedPermission')}
                      size={"small"}
                      value={filterByNameOrCode(sortByName(roles.filter(role => {
                        const rolesInGroups = selectedRoleGroups.flatMap(group => group.roles || []);
                        const isInGroup = rolesInGroups.includes(role.code);
                        const isSelectedDirectly = selectedRoles.some(sr => sr.code === role.code);
                        return isInGroup || isSelectedDirectly;
                      })), allUserRoleSearch)}
                      autoLayout
                      filterDisplay="none"
                      responsiveLayout="scroll"
                      stripedRows
                      dataKey="code"
                  >
                      <Column header={t('columnName')} body={(rowData) => (rowData?.name || "")} />
                  </DataTable>
              </Panel>
          </div>
          </div>
          )}
          
          
          
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {savedUserId && entity === 'user' && canSetRoles &&
                <Button type="submit" label={props.t('setPermissions')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"
                        onClick={savePermissions}/>
              }
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(UserFormComponent);
